import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  style: { gridTemplateRows: 'min-content auto' },
  class: "grid h-full w-full grid-rows-2"
}
const _hoisted_2 = { class: "grid grid-cols-4 gap-4 p-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  id: "map",
  class: "h-full w-full"
}, null, -1)
const _hoisted_4 = { class: "max-h-[350px] border" }
const _hoisted_5 = { class: "border" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_parking_status_card = _resolveComponent("parking-status-card")!
  const _component_map_loader = _resolveComponent("map-loader")!
  const _component_custom_table = _resolveComponent("custom-table")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_grid = _resolveComponent("grid")!
  const _component_main_section = _resolveComponent("main-section")!

  return (_openBlock(), _createBlock(_component_main_section, { "is-map": true }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_parking_status_card, { "parking-spot-count": _ctx.parkingSpotCount }, null, 8, ["parking-spot-count"])
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_map_loader, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_grid, {
          "column-number": 2,
          padding: "p-4"
        }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_grid, { "row-number": 2 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_custom_table, {
                    "force-refresh": true,
                    "is-action-list-not-displayed": true,
                    "remove-table-header": true,
                    "show-per-page": 8,
                    "table-data": _ctx.dashboardEventsData,
                    "table-headers": _ctx.tableHeaders,
                    "table-height": "100%"
                  }, null, 8, ["table-data", "table-headers"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(), _createBlock(_component_apexchart, {
                    key: _ctx.chartSeries.length,
                    ref: "apexChart",
                    options: _ctx.chartOptions,
                    series: _ctx.chartSeries,
                    height: "320"
                  }, null, 8, ["options", "series"]))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}